var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", viewBox: "0 0 20 20" }, props),
    React.createElement("path", { fillRule: "evenodd", d: "M17 9.714c-.004-.789-.516-1.473-1.238-1.657l-1.497-3.703A.54.54 0 0 0 13.769 4H6.231a.537.537 0 0 0-.474.32L4.238 8.046C3.512 8.23 3 8.92 3 9.714v4h1.077v1.143c0 .631.482 1.143 1.077 1.143s1.077-.512 1.077-1.143v-1.143h7.538v1.143c0 .631.482 1.143 1.077 1.143s1.077-.512 1.077-1.143v-1.143H17v-4zM6.554 5.143h6.892L14.576 8H5.424l1.13-2.857zM5.154 12c-.595 0-1.077-.512-1.077-1.143s.482-1.143 1.077-1.143 1.077.512 1.077 1.143S5.749 12 5.154 12zm9.692 0c-.595 0-1.077-.512-1.077-1.143s.482-1.143 1.077-1.143 1.077.512 1.077 1.143S15.441 12 14.846 12z" })
  );
});